import posthog from 'posthog-js';

// Keep track of the last identified user so we don\'t spam PostHog inside one session
let lastIdentifiedId = null;

const posthogMiddleware = store => next => action => {
  const result = next(action);

  switch (action.type) {
    case 'auth/login':
    case 'auth/restoreSession': {
      const authState = store.getState().auth;
      const { user: userPayload } = authState; // { token, user }

      // Guard against missing data
      const distinctId = userPayload?.user?.id;
      if (distinctId && distinctId !== lastIdentifiedId) {
        posthog.identify(distinctId, {
          email: userPayload.user.email,
          firstName: userPayload.user.firstName,
          lastName: userPayload.user.lastName,
        });
        lastIdentifiedId = distinctId;
      }
      break;
    }

    case 'auth/logout': {
      posthog.reset();
      lastIdentifiedId = null;
      break;
    }

    default:
      // ignore other actions
      break;
  }

  return result;
};

export default posthogMiddleware; 